import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export interface EnviromentVariables {
  NEXT_PUBLIC_SERVICES_URL: string;
  NEXT_PUBLIC_ALLOW_NEW_SUBSCRIPTIONS: string;
}

export const env: EnviromentVariables = publicRuntimeConfig;
